export const DEFAULT_SUPPORT_EMAIL = 'support@explo.co';
